module.exports = __webpack_public_path__ + "img/5.8d0f6cf9.webp";